export default "__VITE_ASSET__1e4319c4__"